import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer

let service = new services();
// import ProductForm from '../../../components/product/ProductForm.vue'
// import ProductItemForm from '../../../components/product/ProductItemForm.vue'
// import ProductCartActions from '../../../components/product/ProductCartActions.vue'

//let service = new services();

import {
  ADD_TO_CART,
  REMOVE_FROM_CART
} from '../../store/mutation-types'
export default {
    name: 'Cart',
    data () {
        return {
          user: {},
          selected_order:[],
          checkout_orders: {},
          delivery_details: [],
          payment_details: {},
          payment_mode:"",
          request_page: "orders",
          checked_out: [],
          processed_checkout_orders: [],
          sorted_cart: [],
          orders: [],
          cart: this.$store.state.cart,
          img_product_url: service.imageProductsURL,
          item_delivery_fee:"",
          delivery_fee: "",
          payment_option: "",
          total_order_amt: 0.0,
          total_orders_amount:0.0,
          states:{},
          cities:[],
          loading:true,
        }
      },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        // 'product-form': ProductForm,
        // "product-item-form": ProductItemForm,
        // 'add-to-cart-button': ProductCartActions
      },
      computed: {
        // a computed getter
        // totalDeliveryFee: function () {
        //     this.sorted_cart.forEach(function(element) {
        //         console.log(element['delivery_option_fee'])
        //         /////this.total_delivery_fee += element['delivery_option_fee']
        //         return element['delivery_option_fee']
        //     });
        // }
      },
     methods:{
        removeFromCart (payload) {
            this.$store.commit(REMOVE_FROM_CART, payload)
        },

        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state,i){
            service.getCities(this,state).then(response => {
                if(response.body.status == 200) {
                    this.cities =  response.body.data;
                //     this.$set(this.checkout_orders[i].cities = response.body.data);
                //    // setTimeout(function () {
                //         this.checkout_orders[i].cities = response.body.data;
                //    // }, 1500)
                //     this.$nextTick(function () {
                //         // DOM is now updated
                //         this.checkout_orders[i].cities = response.body.data;
                //       })
                }
            }).catch((err) => {})
        },

        // displayDeliveryOptions(i,order){
        //     this.checkout_orders[i].display_delivery = true;
        // },
       
        displayDeliveryOptions(order){
            this.selected_order = [];
            this.selected_order = order;
            if(this.selected_order.display_delivery){
                this.selected_order.display_delivery = false;
            }else{
                this.selected_order.display_delivery = true;
            }
        },
       
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //this.checkout();
                            if(this.$route.query["order"]){
                                this.getCheckoutOrder()
                            }else{
                                this.getCheckoutOrders();
                            }
                            this.getUserDeliveryDetails();
                        }, this);
                    }else {
                    // this.$router.push('login');
                    }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                        console.log(err)
                    }
                })
            }else {
            // this.$router.push('login');
            }
        },

    getCheckoutOrder(){
        service.getCheckoutOrder(this, this.$route.query["order"]).then(response => {
            if(response.body.status == 200) {
                this.checkout_orders = response.body.data;
                this.total_orders_amount = response.body.data_total_orders_amount;
                this.payment_details = response.body.payment_data;
                this.loading = false;
                //add some settings
                this.checkout_orders.forEach(function(order){
                    order.display_delivery = false; //initiate toggle effect
                },this);
            }
        }).catch((err) => {
            //route to orders
            this.$router.push("orders");    
            //console.log(err) //possibly a load payment error
        })
    },

    getCheckoutOrders(){
        service.getCheckoutOrders(this, this.user.user_id).then(response => {
            if(response.body.status == 200) {
                this.checkout_orders = response.body.data;
                
                this.total_orders_amount = response.body.data_total_orders_amount;
                this.payment_details = response.body.payment_data;
                this.loading = false;
                //add some settings
                this.checkout_orders.forEach(function(order){
                    order.display_delivery = false; //initiate toggle effect
                    order.cities = {};
                },this);
            }else{
                this.$router.push("orders");  //no checkout items
            }
        }).catch((err) => {
            //route to orders
            //this.$router.push("orders");    
            console.log(err) //possibly a load payment error
        })
    },

    getUserDeliveryDetails(){
        service.getUserDeliveryDetails(this, this.user.user_id).then(response => {
            if(response.body.status == 200) {
                this.delivery_details = response.body.data;
            }
        }).catch((err) => {
            //console.log(err) //possibly a load payment error
        })
    },

    calc_delivery_fee(i,option){
        //subtract current delivery fee from sellpoint total order and general total order
        this.total_order_amt -= this.checkout_orders[i].order_delivery_fee; //general
        this.checkout_orders[i].order_total -= this.checkout_orders[i].order_delivery_fee; //sellpoint

        //set new sellpoint delivery charge
        this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
        this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;
        this.checkout_orders[i].order_delivery_city = option.business_delivery_option;

        //add the delivery charge to ellpoint total order and general total order
        this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
        this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;

        //update delivery fee with new one
        this.total_order_amt += option.business_delivery_option_price; //general
        this.checkout_orders[i].order_total += option.business_delivery_option_price; //sellpoint

        //update address
        this.delivery_details.forEach(function(detail) {
            if(detail.user_delivery_city == option.business_delivery_option){
                //empty previous city delivery addresses
                this.checkout_orders[i].order_user_delivery_addresses = [];
                //now push matching addresses to this city
                this.checkout_orders[i].order_user_delivery_addresses.push(detail);
            }
            
        }, this);
    },

    calc_product_specific_delivery_fee(i,i2,option){
        //subtract current delivery fee from sellpoint total order and general total order
        this.total_order_amt -= this.checkout_orders[i].order_items[i2].order_delivery_fee; //general
        this.checkout_orders[i].order_total -= this.checkout_orders[i].order_items[i2].order_delivery_fee; //sellpoint

        //set new product delivery charge
        this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
        this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;
        this.checkout_orders[i].order_items[i2].order_delivery_city = option.business_delivery_option;

        //add the delivery charge to sellpoint total order and general total order
        this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
        this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;

        //update delivery fee with new one
        this.total_order_amt += option.business_delivery_option_price; //general
        this.checkout_orders[i].order_total += option.business_delivery_option_price; //sellpoint

        //update address
        //empty previous city delivery addresses
        this.checkout_orders[i].order_items[i2].order_user_delivery_addresses = [];
                
        this.delivery_details.forEach(function(detail) {
            if(detail.address_city == option.business_delivery_option_city_id){
                //now push matching addresses to this city
                this.checkout_orders[i].order_items[i2].order_user_delivery_addresses.push(detail);
            }else{
              //  console.log("pho"+" "+detail.address_city+"--"+option.business_delivery_option_city_id);
            }
        }, this);
    },

    setUserDeliveryAddress(i,city){
        this.delivery_details.forEach(function(detail) {
            if(detail.user_delivery_city == city){
                //console.log
                this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
            }
        }, this);
    },

    setPaymentOption(option){
        this.payment_mode = option;
    },
    
    pre_checkout(){
      //check login
      this.preset();
    },

    // addToCheckout(item,group_index,item_index){
    //     this.checked_out.push(item);
    //     this.sorted_cart[group_index][1][item_index].product_checked = true; //[1] means the position of the items in a sellpoint as added in sorted_cart
    //     //caculate group store total order amount
    //     this.sorted_cart[group_index].total_order_amt += (item.product_item_order_quantity * item.product_item_price);
    //     //calculate general total order amount
    //     this.total_order_amt += (item.product_item_order_quantity * item.product_item_price);
    // },
      
    // removeFromCheckout(item,group_index,item_index){
    //     const index = this.checked_out.findIndex(p => p._id === item._id) //best removal
    //     this.checked_out.splice(index, 1);
    //     this.sorted_cart[group_index][1][item_index].product_checked = false;
    //     //deduct group store total order amount
    //     this.sorted_cart[group_index].total_order_amt -= (item.product_item_order_quantity * item.product_item_price);
    //     //deduct general total order amount
    //     this.total_order_amt -= (item.product_item_order_quantity * item.product_item_price);
    // },

    

    processPayment(){
        let process_errors = [];
        //validate all addresses are set
        this.checkout_orders.forEach(function(order) {
            if(order.order_user_delivery_address == undefined && order.order_user_new_delivery_address == undefined){
                process_errors.push("Please enter delivery address for "+order.order_business)
            }
            // if(order.order_delivery_not_set && (order.order_delivery_city == undefined)){
            //     process_errors.push("Please select delivery location for "+order.order_business)
            // }//commented for now till city issue fixed
            //for order items
            order.order_items.forEach(function(item) {
                if(item.order_delivery_city){
                    if(item.order_user_delivery_address == undefined && item.order_user_new_delivery_address == undefined){
                        process_errors.push("Please enter delivery address for "+item.product_name);
                    }
                }
            }, this);
        }, this);
        if(process_errors.length != 0){
            process_errors.forEach(function(error) {
                toastr.error(error); 
            }, this);
        }else{
            this.processCardPayment(this.payment_details);
            // if(this.payment_mode == "card"){
            //     this.processCardPayment(this.payment_details);
            //     //this.updatePayment(this.payment_details.payment_ref);
            // }
            // if(this.payment_mode == "paycode"){
            //     this.processPayCodePayment();
            // }        
        }
    },

     //connect to a payment gateway
     processCardPayment(data) {
        //test--//this.updatePayment("ppp")
      let obj = this;
      //this.amount_paid = data.plan_amount;
      var handler = PaystackPop.setup({
      key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
      Name: data.payment_payer_name,
      // email: data.plan_user_email || "admin@sellpoints.ng",
      email: "keneinfostream@gmail.com",
      amount:  (Math.round(data.payment_amount * 100)),//(data.plan_amount * 100), //in kobo
      ref: data.payment_ref,
      metadata: {
          custom_fields: [
              {
                  display_name: "",
                  variable_name: "",
                  value: data.payment_payer_name
              },
              {
                  display_name: "Service",
                  variable_name: "service_type",
                  value: data.payment_service
              }
              
          ]
      },
      
      callback: function(response){
        obj.updatePayment(response.trxref); 
          
      },
      onClose: function(){
          alert('window closed');
      }
      }); 
      handler.openIframe();
  },

  // update payments
  updatePayment(payment_ref) {

    var payload = {
       payment_order_ref: payment_ref,
       payment_user_id: this.user.user_id,
       payment_orders: this.checkout_orders
    }
    let navi = this.$router;
    
    if(payment_ref != "") {
       service.updatePayment(this, payload).then(data => {
           if(data.body.status == 201) {
               toastr.success("Payment Processed!", "Success!");
               
               if(this.request_page != ''){
                   this.$router.push(this.request_page);
               }else {
                   this.$router.go('/');
               }
           }else {
            //console.log("error")
               toastr.error('Sorry, could not update payment', 'Warning!');
           }
       }).catch((err) => {
           if(err) {
              // console.log(err)
               toastr.error('Sorry, could not process information', 'Warning!');
           }
       })
    }else {
        toastr.error('Something went wrong', 'Warning!');
    }
    
  },

  },
  created(){
    document.title = "Checkout" + " | SP";
    //this.prepCart();
    this.preset();
    this.getStates();
  }
     
}


// WEBPACK FOOTER //
// ./src/pages/Checkout/script.js